"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mui = require("@ori-ui/mui");
const productListClasses = (0, _mui.generateUtilityClasses)('ProductList', ['root', 'list', 'pagination', 'carousel']);
var _default = exports.default = productListClasses;
